module.exports = __webpack_public_path__ + "static/media/bloggerIO.87b7c402.jpg";